import { CaceisApiErrorCodesPtBr } from "./languages/caceis-api-errors-pt-br";


const errorsSource = CaceisApiErrorCodesPtBr;

export const CaceisApiErrors = {
    ...errorsSource
}